import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { ApiManager } from '../../core/api-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';


export default function Entry() {

    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);


    useEffect(() => {
        init()
    }, [id]);

    
    async function init() {
        let body = {
            id: id
        }
        var response = await ApiManager.sendRequest('/public/get_entry', body)
        if(response.success === 1) {
            console.warn(response)
            if(response.body.length > 0) {
                setData(response.body[0])
            }
            else {
                setErrors('Errore. Articolo non trovato.')
            }
        }
        else {
            setErrors('Errore. Articolo non trovato.')
        }
    }



    if (data !== null) {
        return (
            <>
                <Helmet>
                    <title>{data.metaTitle}</title>
                    <meta name="description" content={data.metaDescription} />
                </Helmet>

                <Container fluid='md' className='mt-5 mb-5'>
                    <Container fluid='xs'>
                        <h1>{data.title}</h1>
                        <p className='small text-muted'>{data.date && moment(data.date).format('DD/MM/YYYY HH:mm')}</p>
                        <div className='content' dangerouslySetInnerHTML={{ __html: data.content }}></div>
                    </Container>
                </Container>
            </>
        )
    }
    else {
        return (
            <Container fluid='md' className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="secondary" />
                    <p className='text-secondary'>Loading</p>
                </div>
            </Container>
        )
    }
};